<template>
  <BaseGrid container>
    <BaseGrid>
      <BaseButton
        :loading="isLoading"
        fullWidth
        color="inverted"
        @click="onSaveModal"
        v-test="'newsletterSave'"
      >
        {{ $t('global.actions.save') }}
      </BaseButton>
    </BaseGrid>
    <BaseGrid>
      <BaseButton
        :loading="isLoading"
        fullWidth
        @click="onSendModal"
        v-test="'sendNewsletter'"
      >
        {{ $t('global.actions.send') }}
      </BaseButton>
    </BaseGrid>
  </BaseGrid>
  <SaveTemplate
    v-if="showSaveTemplateModal"
    @close="showSaveTemplateModal = false"
  />
  <SendTemplate
    v-if="showSendTemplateModal"
    @close="showSendTemplateModal = false"
  />
  <SendTemplateWarning
    v-if="showSendTemplateWarningModal"
    @close="showSendTemplateWarningModal = false"
    @save="
      showSendTemplateWarningModal = false;
      showSaveTemplateModal = true;
    "
  />
</template>

<script
  lang="ts"
  setup
>
import { storeToRefs } from 'pinia';
import { computed, ref } from 'vue';
import SaveTemplate from '@/modules/marketing/modals/SaveTemplate.vue';
import SendTemplate from '@/modules/marketing/modals/SendTemplate.vue';
import SendTemplateWarning from '@/modules/marketing/modals/SendTemplateWarning.vue';
import { useCompanyStore } from '@/stores/company';
import { useMarketingStore } from '../../../store';

const { allowedToMassSend } = useCompanyStore();
const isLoading = ref(false);
const showSaveTemplateModal = ref(false);
const showSendTemplateModal = ref(false);
const showSendTemplateWarningModal = ref(false);

const { isInvalid, hasDeliverySchedule, isSubmitted } = storeToRefs(
  useMarketingStore(),
);

const sendingIsDisabled = computed(() => !allowedToMassSend);

const onSendModal = () => {
  isSubmitted.value = true;

  if (isInvalid.value) {
    return;
  }

  if (sendingIsDisabled.value) {
    showSendTemplateWarningModal.value = true;
  } else {
    showSendTemplateModal.value = true;
  }
};

const onSaveModal = () => {
  if (hasDeliverySchedule.value) {
    isSubmitted.value = true;
    if (isInvalid.value) {
      return;
    }
  }

  isSubmitted.value = false;
  showSaveTemplateModal.value = true;
};
</script>
